import { MakingRecordAssessments, UploadAudioFile, Assessment, MatchingLearning, Assessments, Payments } from 'components'
import { transcription, createAssessment, uploadAudioFile, rating, assessment, matchingLearning, createAssessmentRecord, assessmentDefs, testTakers, assessments, allAssessments, createAssessments, assessmentDef, adminAssessments, markingWords, cutAudio, assessmentView, makingRecordAssessments, learningResources, audioTranscription, linguisticLab, audioCutting, dashboard, app, payments, contactUs, users, newsletter, newsletters } from "router/routes";
import { Transcription, MarkingWords, MarkingWordsAssessments, TranscriptionAssessments, AudioCuttingAssessments, AudioCutting } from "pages"

const useAppRoutes = () => {

    const permissionParams = {
        permissionHOC: "hidden",
        role: "read"
    }

    const appRoutes = [
        {
            id: 666,
            path: markingWords,
            element: MarkingWordsAssessments,
            feature: "admin-assessments",
            isGeneralPage: true,
            title: "סימון מילים",
            ...permissionParams
        },
        {
            id: 667,
            path: `/${markingWords}/:assessmentID`,
            element: MarkingWords,
            title: "סימון מילים",
            feature: "admin-assessments",
            ...permissionParams
        },
        {
            id: 555,
            path: audioCutting,
            element: AudioCuttingAssessments,
            title: "חיתוך אודיו",
            feature: "admin-assessments",
            isGeneralPage: true,
            ...permissionParams,
        },
        {
            id: 667,
            path: `/${audioCutting}/:assessmentID`,
            element: AudioCutting,
            title: "חיתוך אודיו",
            feature: "admin-assessments",
            ...permissionParams
        },
        {
            id: 777,
            path: transcription,
            element: TranscriptionAssessments,
            feature: "admin-assessments",
            title: "תעתוק",
            isGeneralPage: true,
            ...permissionParams,
        },
        {
            id: 778,
            path: `/${transcription}/:assessmentID`,
            element: Transcription,
            feature: "admin-assessments",
            title: "תעתוק",
            ...permissionParams
        },
        {
            id: 55,
            path: `/`,
            navigate: app.markingWordsAssessments,
            isGeneralPage: true,
            feature: "admin-assessments",
            ...permissionParams
        }
    ]

    return appRoutes
}

export default useAppRoutes